import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Grid } from 'react-bootstrap'
import Card from '../../components/Card/Card.jsx'
import { constants } from '../../redux/callTakers/actions'
import { commonConstants } from '../../redux/common/actions'
import ReactTable from 'react-table'
import NotificationSystem from 'react-notification-system'
import { style as notificationStyling } from '../../variables/Variables.jsx'
import { getFormattedUser } from '../../services/auth'
import CustomReactTablePagination from '../Components/CustomReactTablePagination'

const { FETCH_ALL_CALL_TAKERS } = constants
const { REQUEST } = commonConstants
const headerStyle = { textAlign: 'center', fontWeight: 'bold', color: '#333333' }
const cellStyle = { textAlign: 'center' }

const ManageUsers = ({ history }) => {
  const { callTakers, success, error, loading } = useSelector(state => state.callTakers)
  const dispatch = useDispatch()
  const notificationSystem = useRef()
  const [alert, ] = useState(null)
  const [_notificationSystem, setNotificationSystem] = useState({})

  // initial page fetch
  useEffect(() => {
    dispatch({ type: FETCH_ALL_CALL_TAKERS + REQUEST })
    setNotificationSystem(notificationSystem)
    return () => {}
  }, [])
  // retrieve admin privilege/user if applicable
  const [, setHasAdmin] = useState(true)
  const [, setSelectedScheduleUser] = useState(null)
  useEffect(() => {
    const getAuth = async() => {
      const user = await getFormattedUser()
      const hasAdmin = user && user.roles && user.roles.includes('SuperAdmin')
      setHasAdmin(hasAdmin)
      setSelectedScheduleUser(user.id)
    }
    getAuth().then()
  }, [])
  // handle ajax side effects
  useEffect(() => {
    const notificationSystem = _notificationSystem.current
    if (notificationSystem && success.message) { notificationSystem.addNotification({ message: success.message, level: 'info', position: 'tc' }) }
    if (notificationSystem && error.message) { notificationSystem.addNotification({ message: error.message, level: 'error', position: 'tc' }) }
    return () => {}
  }, [success.message, error.message])
  // handle onClick row navigation
  const [historyNavigation, setHistoryNavigation] = useState({ enabled: false, id: null })
  useEffect(() => {
    if (historyNavigation.enabled) {
      history.push(`/admin/user/${historyNavigation.id}`)
    }
    return () => {}
  },[historyNavigation.enabled])
  // handle scroll to top for notifications
  useEffect(() => {
    // THIS IS SCREWY - Desktop works fine, Mobile scrolls to top quickly then back to original position - 2x fixed this
    document.getElementById('top-of-the-form-to-ya').scrollIntoView(true)
    document.getElementById('top-of-the-form-to-ya').scrollIntoView(true)
    return () => {}
  }, [success.message, error.message])

  const columns = [
    { Header: 'Id', accessor: 'id', show: false, editable: 'never', headerStyle },
    { Header: 'First Name', accessor: 'firstName', headerStyle, style: cellStyle },
    { Header: 'Last Name', accessor: 'lastName', headerStyle, style: cellStyle },
    { Header: 'Email', accessor: 'email', headerStyle, style: cellStyle },
    { Header: 'User Name', accessor: 'username', headerStyle, style: cellStyle },
    { Header: 'Cell Phone', accessor: 'cellPhone', headerStyle, style: cellStyle },
    { Header: 'Birth Day', accessor: 'birthDay', headerStyle, style: cellStyle },
    { Header: 'Birth Month', accessor: 'birthMonth', headerStyle, style: cellStyle },
    { Header: 'Address', accessor: 'address', headerStyle, style: cellStyle },
    { Header: 'Zip/Postal', accessor: 'zip', headerStyle, style: cellStyle },
    { Header: 'City', accessor: 'city', headerStyle, style: cellStyle },
    { Header: 'State', accessor: 'location', headerStyle, style: cellStyle },
    { Header: 'Country', accessor: 'country', headerStyle, style: cellStyle },
    { Header: 'Training City', accessor: 'initialTrainingClassCity', headerStyle, style: cellStyle },
    { Header: 'Training State/Province', accessor: 'initialTrainingClassLocation', headerStyle, style: cellStyle },
    { Header: 'Training Date', accessor: 'initialTrainingClassDate', headerStyle, style: cellStyle },
    { Header: 'Class #', accessor: 'initialTrainingClassNumber', headerStyle, style: cellStyle },
    { Header: 'Available for Scheduling', accessor: 'availableForScheduling', headerStyle, style: cellStyle },
    { Header: 'User Account Enabled', accessor: 'enabled', headerStyle, style: cellStyle },
    { Header: 'Notes', accessor: 'notes', headerStyle, style: cellStyle },
    { Header: 'Roles', accessor: 'roles', headerStyle, style: cellStyle }
  ]

  const filterMethod = (filter, row, column) => {
    const id = filter.pivotId || filter.id
    return row[id] !== undefined ? String(row[id].toLowerCase()).startsWith(filter.value.toLowerCase()) : true
  }

  const list = useMemo(() => {
    if(callTakers) {
      return callTakers.map(ct => ({
        ...ct,
        cellPhone: ct.cellPhone?.national || '',
        initialTrainingClassCity: ct.initialTrainingClass?.city || '',
        initialTrainingClassLocation: ct.initialTrainingClass?.location || '',
        initialTrainingClassDate: ct.initialTrainingClass?.date || '',
        initialTrainingClassNumber: ct.initialTrainingClass?.number || '',
        enabled: ct.enabled ? 'Yes' : 'No',
        availableForScheduling: ct.availableForScheduling ? 'Yes' : 'No',
        roles: ct.roles?.join(', ') || ''
      }))
    } else {
      return []
    }
  }, [callTakers])

  return (
    <div className='main-content'>
      <NotificationSystem ref={notificationSystem} style={notificationStyling} />
      {alert}
      <Grid fluid>
        <Card
          content={
            <ReactTable
              PaginationComponent={CustomReactTablePagination}
              showTotalPages={true}
              canNextFromData={false}
              data={list}
              filterable
              columns={columns}
              defaultPageSize={100}
              defaultFilterMethod={filterMethod}
              showPaginationTop
              sortable
              loading={loading.source === FETCH_ALL_CALL_TAKERS}
              className="-striped -highlight row-pointer"
              getTdProps={(_state, rowInfo, column) => {
                if (column && ['website', 'actions'].includes(column.id)) {
                  return {}
                } else if (rowInfo && rowInfo.row) {
                  return {
                    onClick: () => setHistoryNavigation({ enabled: true, id: rowInfo.row.id })
                  }
                } else {
                  return {}
                }
              }}
            />
          }
        />
      </Grid>
    </div>
  )
}

export default ManageUsers
